import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Prisma 데이터에서 BigInt를 문자열로 변환하여 JSON 직렬화 가능하게 만드는 함수
 */
export function serializePrismaData<T>(data: T): T {
  return JSON.parse(
    JSON.stringify(data, (key, value) => 
      typeof value === 'bigint' ? value.toString() : value
    )
  );
}

/**
 * 날짜를 YYYY.MM.DD 형식으로 포맷팅하는 함수
 */
export function formatDate(dateString: string): string {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  
  if (isNaN(date.getTime())) return '';
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  return `${year}.${month}.${day}`;
}
